import { useCruxJsDisplayConfig } from "./useCruxJsDisplayConfig";

export const useProductTypeHelper = () => {
  const { cruxJsDisplayConfig } = useCruxJsDisplayConfig();

  return {
    productTypeHelper: cruxJsDisplayConfig?.getProductTypeHelper(),
  };
};
